export const SET_LAYOUT = "Set Layout";
export const FETCH_PAGE = "Fetch Page Layout";
export const UPDATE_CHAT = "Update Chat";

export const FETCH_QUESTIONS = "Fetch Questions";
export const FETCH_QUESTIONS_FAILURE = "Fetch Questions Failure";

export const FETCH_TEST = "Fetch Test";
export const FETCH_TEST_FAILURE = "Fetch Test Failure";

export const FECTH_STORIES = "Fecth Stories";
export const FECTH_STORY = "Fecth Story";

export const SAVE_ANSWERS = "Save Answers";
export const SAVE_ANSWERS_FAILURE = "Save Answers Failure";

export const UPDATE_ANSWERS = "Update Answers";

export const FETCH_USER_STATE = "show user state";
export const LIST_SEARCH_USERS = "fetch all selected users";

export const SAVE_ANSWERS_FORM = "Save Answers Form";
export const SAVE_ANSWERS_FORM_FAILURE = "Save Answers Form Failure";

export const FETCH_USER_SUCCESS = "Fetch User Success";
export const FETCH_USER_FAILURE = "Fetch User Failure";
export const SAVE_TOKEN = "Save Token";
export const TOGGLE_LOADING = "Toggle Loading";
export const LOGOUT = "Logout";
//---------------------------------------------------------------------
export const FECTH_FRIENDS = "Send Friends";
export const FECTH_CONTACT = "Send Data Contact";
export const STATE_CHAT = "State Welcome Chat";
export const FECTH_PROFILE = "Data Profiles";
export const FECTH_PROFILES = "users Profiles";
export const APPEND_SEEN_USER = "Append seen users";
export const TRAVERSE_TO_ID = "TRaverse seen users to ID";
export const LIST_COUNTRIES = "List Countries";
export const LIST_FAVORITES = "List Favorites";
export const LIST_RECIPROCAL = "List Favorites Reciprocal";
export const LIST_ANSWERS = "List Answers";
export const FECTH_ANSWERS = "List Users Profile";
export const LIST_NOTIFICATIONS = "List Notifications";
export const LIST_SEEN = "Show Count Seen Profiles";
export const SEEN_PROFILES = "List Profiles Seen";
export const SEND_SMILE = "Send Smile User";
export const LIST_BLOCKED = "List blocked profiles";

export const SET_LOCALE = "Set locale";
export const SEND_COMPLAINTS = "Send complaints";

export const SHOW_IMAGES = "Show Images Profiles";

export const MORE_PROFILES = "More Friends 20";

export const SHOW_SETTINGS = "Show settings";

export const STATE_CALL = "Call State";
export const CONNECTION = "Connection";

export const SET_CURRENT_PAGE_PAGINATION = "Current page pagination";

export const STORE_SEARCH_PARAMS = "Store search params";

export const CONTROL_STATUS = "Control Status";
